"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetTypes = void 0;
var StreetTypes;
(function (StreetTypes) {
    StreetTypes["ALY"] = "Aly";
    StreetTypes["ANX"] = "Anx";
    StreetTypes["ARC"] = "Arc";
    StreetTypes["AVE"] = "Ave";
    StreetTypes["BCH"] = "Bch";
    StreetTypes["BG"] = "Bg";
    StreetTypes["BGS"] = "Bgs";
    StreetTypes["BLF"] = "Blf";
    StreetTypes["BLFS"] = "Blfs";
    StreetTypes["BLVD"] = "Blvd";
    StreetTypes["BND"] = "Bnd";
    StreetTypes["BR"] = "Br";
    StreetTypes["BRG"] = "Brg";
    StreetTypes["BRK"] = "Brk";
    StreetTypes["BRKS"] = "Brks";
    StreetTypes["BTM"] = "Btm";
    StreetTypes["BYP"] = "Byp";
    StreetTypes["BYU"] = "Byu";
    StreetTypes["CIR"] = "Cir";
    StreetTypes["CIRS"] = "Cirs";
    StreetTypes["CLB"] = "Clb";
    StreetTypes["CLF"] = "Clf";
    StreetTypes["CLFS"] = "Clfs";
    StreetTypes["CMN"] = "Cmn";
    StreetTypes["CMNS"] = "Cmns";
    StreetTypes["COR"] = "Cor";
    StreetTypes["CORS"] = "Cors";
    StreetTypes["CP"] = "Cp";
    StreetTypes["CPE"] = "Cpe";
    StreetTypes["CRES"] = "Cres";
    StreetTypes["CRK"] = "Crk";
    StreetTypes["CRSE"] = "Crse";
    StreetTypes["CRST"] = "Crst";
    StreetTypes["CSWY"] = "Cswy";
    StreetTypes["CT"] = "Ct";
    StreetTypes["CTR"] = "Ctr";
    StreetTypes["CTRS"] = "Ctrs";
    StreetTypes["CTS"] = "Cts";
    StreetTypes["CURV"] = "Curv";
    StreetTypes["CV"] = "Cv";
    StreetTypes["CVS"] = "Cvs";
    StreetTypes["CYN"] = "Cyn";
    StreetTypes["DL"] = "Dl";
    StreetTypes["DM"] = "Dm";
    StreetTypes["DR"] = "Dr";
    StreetTypes["DRS"] = "Drs";
    StreetTypes["DV"] = "Dv";
    StreetTypes["EST"] = "Est";
    StreetTypes["ESTS"] = "Ests";
    StreetTypes["EXPY"] = "Expy";
    StreetTypes["EXT"] = "Ext";
    StreetTypes["EXTS"] = "Exts";
    StreetTypes["FALL"] = "Fall";
    StreetTypes["FLD"] = "Fld";
    StreetTypes["FLDS"] = "Flds";
    StreetTypes["FLS"] = "Fls";
    StreetTypes["FLT"] = "Flt";
    StreetTypes["FLTS"] = "Flts";
    StreetTypes["FRD"] = "Frd";
    StreetTypes["FRDS"] = "Frds";
    StreetTypes["FRG"] = "Frg";
    StreetTypes["FRGS"] = "Frgs";
    StreetTypes["FRK"] = "Frk";
    StreetTypes["FRKS"] = "Frks";
    StreetTypes["FRST"] = "Frst";
    StreetTypes["FRY"] = "Fry";
    StreetTypes["FT"] = "Ft";
    StreetTypes["FWY"] = "Fwy";
    StreetTypes["GDN"] = "Gdn";
    StreetTypes["GDNS"] = "Gdns";
    StreetTypes["GLN"] = "Gln";
    StreetTypes["GLNS"] = "Glns";
    StreetTypes["GRN"] = "Grn";
    StreetTypes["GRNS"] = "Grns";
    StreetTypes["GRV"] = "Grv";
    StreetTypes["GRVS"] = "Grvs";
    StreetTypes["GTWY"] = "Gtwy";
    StreetTypes["HBR"] = "Hbr";
    StreetTypes["HBRS"] = "Hbrs";
    StreetTypes["HL"] = "Hl";
    StreetTypes["HLS"] = "Hls";
    StreetTypes["HOLW"] = "Holw";
    StreetTypes["HTS"] = "Hts";
    StreetTypes["HVN"] = "Hvn";
    StreetTypes["HWY"] = "Hwy";
    StreetTypes["INLT"] = "Inlt";
    StreetTypes["IS"] = "Is";
    StreetTypes["ISLE"] = "Isle";
    StreetTypes["ISS"] = "Iss";
    StreetTypes["JCT"] = "Jct";
    StreetTypes["JCTS"] = "Jcts";
    StreetTypes["KNL"] = "Knl";
    StreetTypes["KNLS"] = "Knls";
    StreetTypes["KY"] = "Ky";
    StreetTypes["KYS"] = "Kys";
    StreetTypes["LAND"] = "Land";
    StreetTypes["LCK"] = "Lck";
    StreetTypes["LCKS"] = "Lcks";
    StreetTypes["LDG"] = "Ldg";
    StreetTypes["LF"] = "Lf";
    StreetTypes["LGT"] = "Lgt";
    StreetTypes["LGTS"] = "Lgts";
    StreetTypes["LK"] = "Lk";
    StreetTypes["LKS"] = "Lks";
    StreetTypes["LN"] = "Ln";
    StreetTypes["LNDG"] = "Lndg";
    StreetTypes["LOOP"] = "Loop";
    StreetTypes["MALL"] = "Mall";
    StreetTypes["MDW"] = "Mdw";
    StreetTypes["MDWS"] = "Mdws";
    StreetTypes["MEWS"] = "Mews";
    StreetTypes["ML"] = "Ml";
    StreetTypes["MLS"] = "Mls";
    StreetTypes["MNR"] = "Mnr";
    StreetTypes["MNRS"] = "Mnrs";
    StreetTypes["MSN"] = "Msn";
    StreetTypes["MT"] = "Mt";
    StreetTypes["MTN"] = "Mtn";
    StreetTypes["MTNS"] = "Mtns";
    StreetTypes["MTWY"] = "Mtwy";
    StreetTypes["NCK"] = "Nck";
    StreetTypes["OPAS"] = "Opas";
    StreetTypes["ORCH"] = "Orch";
    StreetTypes["OVAL"] = "Oval";
    StreetTypes["PARK"] = "Park";
    StreetTypes["PASS"] = "Pass";
    StreetTypes["PATH"] = "Path";
    StreetTypes["PIKE"] = "Pike";
    StreetTypes["PKWY"] = "Pkwy";
    StreetTypes["PL"] = "Pl";
    StreetTypes["PLN"] = "Pln";
    StreetTypes["PLNS"] = "Plns";
    StreetTypes["PLZ"] = "Plz";
    StreetTypes["PNE"] = "Pne";
    StreetTypes["PNES"] = "Pnes";
    StreetTypes["PR"] = "Pr";
    StreetTypes["PRT"] = "Prt";
    StreetTypes["PRTS"] = "Prts";
    StreetTypes["PSGE"] = "Psge";
    StreetTypes["PT"] = "Pt";
    StreetTypes["PTS"] = "Pts";
    StreetTypes["RADL"] = "Radl";
    StreetTypes["RAMP"] = "Ramp";
    StreetTypes["RD"] = "Rd";
    StreetTypes["RDG"] = "Rdg";
    StreetTypes["RDGS"] = "Rdgs";
    StreetTypes["RDS"] = "Rds";
    StreetTypes["RIV"] = "Riv";
    StreetTypes["RNCH"] = "Rnch";
    StreetTypes["ROW"] = "Row";
    StreetTypes["RPD"] = "Rpd";
    StreetTypes["RPDS"] = "Rpds";
    StreetTypes["RST"] = "Rst";
    StreetTypes["RTE"] = "Rte";
    StreetTypes["RUE"] = "Rue";
    StreetTypes["RUN"] = "Run";
    StreetTypes["SHL"] = "Shl";
    StreetTypes["SHLS"] = "Shls";
    StreetTypes["SHR"] = "Shr";
    StreetTypes["SHRS"] = "Shrs";
    StreetTypes["SKWY"] = "Skwy";
    StreetTypes["SMT"] = "Smt";
    StreetTypes["SPG"] = "Spg";
    StreetTypes["SPGS"] = "Spgs";
    StreetTypes["SPUR"] = "Spur";
    StreetTypes["SQ"] = "Sq";
    StreetTypes["SQS"] = "Sqs";
    StreetTypes["ST"] = "St";
    StreetTypes["STA"] = "Sta";
    StreetTypes["STRA"] = "Stra";
    StreetTypes["STRM"] = "Strm";
    StreetTypes["STS"] = "Sts";
    StreetTypes["TER"] = "Ter";
    StreetTypes["TPKE"] = "Tpke";
    StreetTypes["TRAK"] = "Trak";
    StreetTypes["TRCE"] = "Trce";
    StreetTypes["TRFY"] = "Trfy";
    StreetTypes["TRL"] = "Trl";
    StreetTypes["TRLR"] = "Trlr";
    StreetTypes["TRWY"] = "Trwy";
    StreetTypes["TUNL"] = "Tunl";
    StreetTypes["UN"] = "Un";
    StreetTypes["UNS"] = "Uns";
    StreetTypes["UPAS"] = "Upas";
    StreetTypes["VIA"] = "Via";
    StreetTypes["VIS"] = "Vis";
    StreetTypes["VL"] = "Vl";
    StreetTypes["VLG"] = "Vlg";
    StreetTypes["VLGS"] = "Vlgs";
    StreetTypes["VLY"] = "Vly";
    StreetTypes["VLYS"] = "Vlys";
    StreetTypes["VW"] = "Vw";
    StreetTypes["VWS"] = "Vws";
    StreetTypes["WALK"] = "Walk";
    StreetTypes["WALL"] = "Wall";
    StreetTypes["WAY"] = "Way";
    StreetTypes["WAYS"] = "Ways";
    StreetTypes["WL"] = "Wl";
    StreetTypes["WLS"] = "Wls";
    StreetTypes["XING"] = "Xing";
    StreetTypes["XRD"] = "Xrd";
    StreetTypes["XRDS"] = "Xrds";
})(StreetTypes = exports.StreetTypes || (exports.StreetTypes = {}));
